<template>
  <Dialog
    v-model:visible="visible"
    :closable="false"
    :close-on-escape="false"
    :draggable="false"
    :modal="true"
    :base-z-index="200000"
    class="terms-of-use z-[200000]"
    header="Allgemeine Nutzungsbestimmungen für den Online-Campus und das Learning-Management-System „Moodle“ der FOM Hochschule">
    <template #default>
      <ul class="terms-list">
        <li>
          <p class="fom-copy-m-bold">Präambel</p>
          Die Betreiber des Online-Campus („OC“) der im Bildungsverbund BCW-Gruppe
          zusammengeschlossenen Gesellschaften mit den Bildungseinrichtungen FOM
          Hochschule, eufom Business School der FOM, GoBS, BA, VWA, IIS, BCW
          Weiterbildung und German Sino School of Business & Technology, stellen
          allen Studierenden und Mitarbeitenden der FOM Hochschule für Oekonomie &
          Management gemeinnützige GmbH (FOM Hochschule) sowie den Personen, die für
          die Betreiber des OC im Bereich der Lehre oder Forschung tätig werden, den
          OC u.a. als Plattform zur digitalen Verwaltung ihres Studiums, zur
          Kommunikation und Recherche zur Verfügung. Darüber hinaus nutzt die FOM
          Hochschule das Learning Management System (LMS) Moodle, um das e-Learning
          Angebot der FOM Hochschule zu fördern und auf einer einheitlichen
          Plattform zugänglich zu machen. Die vorliegenden Allgemeinen
          Nutzungsbestimmungen regeln die Nutzung des OC und des LMS.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 1 Geltungsbereich</p>
          Die Allgemeinen Nutzungsbestimmungen gelten für jede/n Nutzer/in, der/die
          den OC und ggfs. auch das LMS als Nutzungsberechtige/r im Sinne des § 2
          der allgemeinen Nutzungsbestimmungen nutzt.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 2 Inhalt des Onlineangebotes</p>
          Die Betreiber des OC übernehmen keinerlei Gewähr für die Aktualität,
          Korrektheit, Vollständigkeit oder Qualität der bereitgestellten
          Informationen. Haftungsansprüche gegen den Betreiber des OC, die auf der
          Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. auf der
          Nutzung fehlerhafter und unvollständiger Informationen gründen, sind
          ausgeschlossen, sofern seitens des Betreibers kein vorsätzliches oder grob
          fahrlässiges Handeln vorliegt. Alle Angebote sind freibleibend und
          unverbindlich. Die Betreiber des OC behalten es sich ausdrücklich vor,
          Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu
          verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise
          oder endgültig einzustellen.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 3 Verweise und Links</p>
          Bei direkten oder indirekten Verweisen auf fremde Webseiten
          ("Hyperlinks"), die außerhalb des Verantwortungsbereiches des OC liegen,
          würde eine Haftungsverpflichtung für den Einstellenden - in keinem Fall
          aber für den Betreiber des OC - ausschließlich in dem Fall in Kraft
          treten, in dem der Einsteller von den Inhalten Kenntnis hat und es ihm
          technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger
          Inhalte zu verhindern.
          <br />
          Der Einstellende sowie die Betreiber des OC erklären hiermit ausdrücklich,
          dass sie zum Zeitpunkt der Linksetzung geprüft haben, dass keine illegalen
          Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle
          und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der
          verlinkten/verknüpften Seiten hat der Einstellende sowie die Betreiber des
          OC keinerlei Einfluss. Deshalb distanzieren sie sich hiermit ausdrücklich
          von allen Inhalten aller verlinkten/verknüpften Seiten, die nach der
          Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb
          des eigenen Internetangebotes gesetzten Links und Verweise sowie für
          Fremdeinträge in eingerichteten Diskussionsforen, Linkverzeichnissen,
          Mailinglisten und in allen anderen Formen von Datenbanken, auf deren
          Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte
          oder unvollständige Inhalte und insbesondere für Schäden, die aus der
          Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen,
          haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht
          derjenige, der über Links auf die jeweilige Veröffentlichung lediglich
          verweist.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 4 Urheber- und Kennzeichenrecht</p>
          Die Betreiber des OC sowie die jeweiligen Einstellenden sind bestrebt, in
          allen Publikationen die Urheberrechte der verwendeten Bilder, Grafiken,
          Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst
          erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu
          nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und
          Texte zurückzugreifen.
          <br />
          Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte
          geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den
          Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten
          der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen
          Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch
          Rechte Dritter geschützt sind!
          <br />
          Das Copyright für veröffentlichte, vom Betreiber des OC selbst erstellte
          Objekte, bleibt allein beim Betreiber des OC. Eine Vervielfältigung oder
          Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in
          anderen elektronischen oder gedruckten Publikationen ist ohne
          ausdrückliche Zustimmung des Betreibers des OC nicht gestattet.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 5 Nutzungsberechtigung</p>
          (1) Nutzungsberechtigt sind alle Studierenden und Mitarbeitenden der
          Betreiber des OC sowie Personen, die für die Betreiber des OC im Bereich
          der Lehre oder Forschung tätig werden. <br />(2) Für Nutzungsberechtigte
          ist die Nutzung des OC und des LMS unentgeltlich.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 6 Anmeldung</p>
          (1) Die Inanspruchnahme des Dienstes erfordert eine vorherige Anmeldung
          der Nutzungsinteressierten. Nutzungsberechtigte der Betreiber des OC
          können sich mit ihrer Matrikelnummer/Nutzernamen und einem individuellen
          plattformspezifischen Passwort im OC und auf der Lernplattform anmelden.
          <br />(2) Die bei der Anmeldung angegebenen Daten müssen korrekt und
          vollständig sein. <br />(3) Nutzungsberechtigte der Betreiber des OC
          verwenden das Passwort, das zu ihrer LoginID gehört. Die Nutzer/innen
          haben dafür Sorge zu tragen, dass Dritte keine Kenntnis von dem Passwort
          erlangen.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 7 Nutzungsbedingungen Profil</p>
          Die Betreiber des OC weisen ausdrücklich darauf hin, dass Einträge im
          persönlichen Profil wahrheitsgemäß vorgenommen werden müssen, da nicht
          wahrheitsgemäße Eingaben zum Tatbestand der Urkundenfälschung (§ 267 StGB)
          führen können.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 8 Pflichten der Nutzer/innen</p>
          (1) Die Weitergabe der E-Mail-Adressen anderer im System registrierter
          Nutzungsberechtigter ist unzulässig.
          <br />(2) Jeder Nutzungsberechtigte ist verpflichtet, sämtliche
          gesetzlichen Bestimmungen, insbesondere die Bestimmungen des Urheberrechts
          und des Datenschutzes, einzuhalten. <br />(3) Jeder Nutzungsberechtigte
          ist selbst dafür verantwortlich, dass die von ihm/ihr eingestellten
          Materialien keine Rechte Dritter verletzen und auch sonst nicht gegen
          rechtliche Vorschriften verstoßen, insbesondere nicht gegen
          urheberrechtliche, wettbewerbsrechtliche oder datenschutzrechtliche
          Vorschriften. Es ist nicht gestattet, urheberrechtlich geschützte Werke
          über den OC oder das LMS auszutauschen, zu nutzen oder zu verbreiten, wenn
          die rechtlichen Voraussetzungen hierfür nicht erfüllt sind. Vor der
          Setzung von Links sind die verlinkten Inhalte auf Rechtsverletzungen zu
          überprüfen. Die Verlinkung auf rechtswidrige Seiten, insbesondere mit
          extremistischem, volksverhetzendem oder beleidigendem Inhalt, ist
          unzulässig. <br />(4) Die Regelungen des Abs. 3 gelten auch für die
          Äußerungen im Rahmen von Kommunikationsfunktionen. <br />(5) Die Nutzer
          des LMS haben über die vorstehenden Pflichten hinaus folgende Pflichten
          einzuhalten: <br />a. Das LMS steht den Nutzungsberechtigten
          ausschließlich zu universitären Zwecken zur Verfügung. Eine anderweitige
          Nutzung, insbesondere zu geschäftlichen, gewerblichen oder privaten
          Zwecken, ist nicht zulässig. <br />b. Der Kontakt zwischen der FOM
          Hochschule und Nutzungsberechtigten wird ausschließlich über den im System
          hinterlegten E-Mail-Account abgewickelt. Nutzungsberechtigte haben die
          Erreichbarkeit unter diesem Account sicherzustellen. <br />c. Eine Nutzung
          der Statistikdaten des LMS für Leistungs- und Verhaltenskontrollen und
          Beurteilungen ist unzulässig.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 9 Missbräuchliche Nutzung</p>
          (1) Der/die Nutzer/in hat jede Art der unzulässigen bzw. missbräuchlichen
          Nutzung des OC und des LMS iSd § 4 dieser Nutzungsbestimmungen zu
          unterlassen.
          <br />(2) Eine missbräuchliche Nutzung liegt insbesondere vor, wenn im
          Rahmen der Nutzung des OC und des LMS <br />a) mit Nutzerkennungen
          gearbeitet wird, deren Nutzung nicht gestattet wurde; <br />b)
          Nutzerkennungen oder Passwörter weitergegeben werden oder keine
          Vorkehrungen getroffen werden, dass unberechtigte Dritte Zugang zum LMS
          und/oder OC erhalten; <br />c) Daten unbefugt verändert, gelöscht,
          unterdrückt oder unbrauchbar gemacht werden; <br />d) Material
          verfassungswidriger Organisationen oder verfassungswidriges, insbesondere
          rassistisches, Gedankengut verbreitet wird; <br />e) Pornographie
          verbreitet wird; <br />f) Delikte gegen die persönliche Ehre, insbesondere
          Beleidigung oder Verleumdung, begangen werden; <br />g) oder sonst gegen
          gesetzliche Vorschriften (z.B. Strafgesetzbuch, Jugendschutzgesetz,
          Datenschutzgesetz, Urheberrechtsgesetz, Markengesetz) oder gegen interne
          Regelungen der OC-Betreiber, insbesondere diese Allgemeinen
          Nutzungsbestimmungen, verstoßen wird; <br />h) das Ansehen der
          OC-Betreiber geschädigt wird oder die Nutzung ihren Interessen
          entgegensteht. <br />(3) Die OC-Betreiber behalten sich vor, den Inhalt
          bereitgestellter Inhalte stichprobenartig zu überprüfen. Sittenwidrige,
          gegen geltendes Recht oder gegen ethische Normen verstoßende Inhalte
          können von den OC-Betreibern ohne Ankündigung entfernt werden.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 10 Ausschluss von der Nutzung</p>
          <br />(1) Nutzer/innen, die gegen die vorliegenden Nutzungsbestimmungen
          verstoßen, können zeitweise oder auf Dauer von der Nutzung des OC und/
          oder des LMS ausgeschlossen werden. Dem Ausschluss gehen grundsätzlich
          eine Aufforderung, das beanstandete Verhalten zu unterlassen und eine
          schriftliche oder mündliche Anhörung der Nutzer/in voraus, in der auf die
          Möglichkeit des Ausschlusses hingewiesen wird. <br />(2) Ausgeschlossene
          Nutzer/innen können wieder zugelassen werden, wenn sichergestellt ist,
          dass das missbräuchliche Verhalten in Zukunft unterlassen wird. <br />(3)
          Die Absätze 1 und 2 gelten sinngemäß auch für den Fall, dass die
          OC-Betreiber den begründeten Verdacht einer systematischen Unterwanderung
          interner Sicherheitsvorkehrungen haben (z.B. E-Mail-Missbrauch, Einbezug
          schädlicher Komponenten wie Viren, Würmer, Trojanische Pferde). <br />(4)
          Die OC Betreiber behalten sich vor, im Sinne einer ökonomischen Verwaltung
          des Systems die Nutzungsberechtigung von Nutzer/innen ohne weitere
          Ankündigung zu löschen, die sich innerhalb der vergangenen zwölf Monate
          nicht mehr am LMS angemeldet haben oder deren FOM Online-Campus-Account
          nicht mehr gültig ist.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 11 Haftung</p>
          (1) Die OC-Betreiber können die ständige Verfügbarkeit der
          Onlineverbindung nicht gewährleisten, da dies auch dem
          Hostingdienstleister nicht möglich ist. Der Hostingdienstleister bemüht
          sich, vorübergehende Betriebsunterbrechungen aufgrund von Wartungszeiten
          und/oder systemimmanenten Störungen des Internets zu vermeiden, die OC
          Betreiber können jedoch auch diesbezüglich keine Gewährleistung
          übernehmen.
          <br />(2) Soweit zwischen dem/der Nutzer/in und den Betreibern des OC
          keine vorrangigen anderweitigen Haftungsvereinbarungen bestehen, haften
          diese einander nur für vorsätzliche und grob fahrlässige
          Pflichtverletzungen. Die Haftung ist nicht eingeschränkt, wenn die
          Pflichtverletzungen wesentliche Pflichten dieser Allgemeinen
          Nutzungsbestimmungen, Schäden aus der Verletzung des Lebens, des Körpers
          oder der Gesundheit, Garantien oder Ansprüche aus dem
          Produkthaftungsgesetz betreffen.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 12 Änderung der Nutzungsbestimmungen</p>
          (1) Die Betreiber des OC behalten sich vor, diese Nutzungsbestimmungen mit
          Wirkung für die Zukunft zu ändern und zu ergänzen. Derzeitiger Stand ist
          September 2021.
          <br />(2) Die Betreiber des OC sind berechtigt, im Einzelfall
          Entscheidungen zu treffen, durch welche die allgemeinen
          Nutzungsbestimmungen konkretisiert oder erweitert werden. <br />(3)
          Änderungen müssen schriftlich im OC oder ggf. im LMS bekannt gegeben
          werden mit einem Verweis auf die Internetseite, auf der die jeweils
          aktuellen Nutzungsbestimmungen einzusehen sind.
        </li>
      </ul>
      <h3>Datenschutzerklärung</h3>
      <ul class="terms-list">
        <li>
          <p class="fom-copy-m-bold">§ 1 Einleitung</p>
          Diese Datenschutzerklärung informiert Sie darüber, welche
          personenbezogenen Daten von Ihnen im Rahmen der Anmeldung zu einem Studium
          und im Rahmen der Erfüllung eines Studienvertrags von uns, der FOM
          Hochschule für Oekonomie & Management gemeinnützige Gesellschaft mbH,
          Leimkugelstraße 6, 45141 Essen („FOM“ oder „wir“), erhoben, verarbeitet
          und/oder genutzt (im Folgenden zusammengefasst als „Verarbeitung“) werden.
        </li>
        <li>
          <p class="fom-copy-m-bold">§ 2 Verantwortliche Stelle, Diensteanbieter</p>
          Die FOM ist die verantwortliche Stelle für die Verarbeitung der
          personenbezogenen Daten im Rahmen der Anmeldung und der Erfüllung eines
          Studienvertrags. Weitere Angaben zu uns können Sie § 9 dieser
          Datenschutzerklärung sowie dem Impressum auf unserer Webseite entnehmen.
        </li>
        <li>
          <p class="fom-copy-m-bold">
            § 3 Zweck und Rechtsgrundlage der Datenverarbeitung
          </p>
          Soweit im Rahmen der Anmeldung personenbezogene Daten von Studienbewerbern
          und Studienbewerberinnen verarbeitet werden, erfolgt dies zur Bearbeitung
          und Verwaltung der Anmeldung. Außerdem können wir Ihre personenbezogenen
          Daten im Rahmen der Missbrauchsvorsorge und Beweisführung verwenden.
          <br />
          Zur Erstellung von Statistiken über den Anmeldungsprozess anonymisieren
          wir Ihre Daten. Die anonymisierten Daten und Statistiken werden
          ausschließlich zu eigenen Zwecken verwendet.
          <br />
          Soweit im Rahmen der Erfüllung des Studienvertrags personenbezogene Daten
          von Ihnen verarbeitet werden, erfolgt dies zur Bearbeitung und Verwaltung
          aller Vorgänge im Zusammenhang mit einem Studium. Außerdem können wir Ihre
          personenbezogenen Daten im Rahmen der Missbrauchsvorsorge und
          Beweisführung verwenden.
          <br />
          Soweit nachfolgend in dieser Datenschutzerklärung nicht weiter
          spezifiziert, ist Rechtsgrundlage für die Verarbeitung Ihrer
          personenbezogenen Daten im Rahmen der Bewerbung und der Erfüllung des
          Studienvertrags Art. 6 Abs. 1 lit. b) der Datenschutzgrundverordnung
          („DSGVO“). Die Missbrauchsvorsorge und Beweisführung beruht auf
          berechtigten Interessen, Art. 6 Abs. 1 lit. f) DSGVO.
          <br />
          Beachten Sie dabei bitte, dass wir Ihre Anmeldung oder einzelne Vorgänge
          im Rahmen der Erfüllung eines Studienvertrags gegebenenfalls nicht
          bearbeiten können, wenn Sie uns nicht die entsprechenden personenbezogenen
          Daten zur Verfügung stellen. Insoweit unterscheidet sich eine Verarbeitung
          aufgrund von Art. 6 Abs. 1 lit. b), c) oder f) DSGVO von einer
          Verarbeitung aufgrund einer ausdrücklichen Einwilligung, die Sie
          gegebenenfalls erteilen.
          <br />
          Soweit Sie uns eine Einwilligung im Sinne von Art. 6 Abs. 1 lit. a), 7
          DSGVO zur Verarbeitung von personenbezogenen Daten für bestimmte Zwecke
          erteilt haben, stellt Ihre Einwilligung die Rechtsgrundlage für diesen
          konkreten Verarbeitungszweck dar. Eine derart erteilte Einwilligung kann
          jederzeit widerrufen werden. Bitte beachten Sie, dass der Widerruf erst
          für die Zukunft wirkt. Verarbeitungen, die vor dem Widerruf erfolgt sind,
          sind davon nicht betroffen.
        </li>
        <li>
          <p class="fom-copy-m-bold">
            § 4 Verwendung der Daten zur Verwaltung, Erfüllung und administrativen
            Abwicklung des Studienvertrages
          </p>
          Die FOM verarbeitet sämtliche Daten, die im Rahmen der Anmeldung oder der
          Erfüllung eines Studienvertrags von Ihnen eingetragen und zur Verfügung
          gestellt werden. Das sind Daten folgender Kategorien: Stammdaten (wie zum
          Beispiel Name, Anschrift und sonstige Kontaktdaten, Geburtsdatum,
          Staatsangehörigkeit), Ihr Foto, Kontoverbindungen, Lebenslauf,
          Informationen zu Ihrem Studiengang und angestrebtem Abschluss, Angaben zu
          Ihrer bisherigen Schulbildung, Angaben zu einem eventuellen Erststudium,
          Angaben zu berufspraktischen Tätigkeiten bzw. Ausbildung, Informationen
          über absolvierte Fortbildungen, Ihr derzeitiger Arbeitgeber und dessen
          Kontaktinformationen sowie Nachweis über die Arbeitnehmerstellung und
          sonstige von Ihnen freiwillig gemachte Angaben.
          <br />
          Im Rahmen der Erfüllung eines Studienvertrags verarbeitet die FOM darüber
          hinaus Daten zur Durchführung und Bearbeitung von Prüfungsleistungen, zur
          Bearbeitung von Gebühren und Forderungen, zu studienvertragsrelevanten
          Anträgen wie beispielsweise Urlaubs- oder Verlängerungssemestern, zu
          Aktivitäten im Online Campus und sonstige von Ihnen freiwillig gemachte
          Angaben.
        </li>
        <li>
          <p class="fom-copy-m-bold">
            § 5 Verwendungen der Daten im Rahmen der Nutzung von digitalen Angeboten
            der FOM
          </p>
          Sofern von Ihnen digitale Angebote der FOM wie die Teilnahme an digitalen
          Lehrveranstaltungen, die Teilnahme an digitalen Prüfungen und digitale
          Lernplattformen in Anspruch genommen werden, werden neben Daten der
          Kategorie Stammdaten folgende ergänzende Daten erhoben und verarbeitet.
          <h4 class="fom-copy-m-bold">a) Lernplattformen z.B. Moodle</h4>

          <ul>
            <li>
              E-Mailadresse und Anmeldename und weitere Daten, die Sie in Ihrem
              Profil einstellen
            </li>
            <li>persönliches Kennwort (kann geändert werden)</li>
            <li>belegte Kursveranstaltungen</li>
            <li>Aktivitäten in Kursen, Forenbeiträge</li>
            <li>bearbeitete Lernaktivitäten und Lernergebnisse</li>
            <li>
              Protokolldaten über die Aktivität des Nutzers unter Angabe seiner
              IP-Adresse, durchgeführter Aktivitäten, Inhalt der Nutzereingabe und
              Zeitpunkt der Aktivität.
            </li>
          </ul>
          <h4 class="fom-copy-m-bold">
            b) Digitale Lehrveranstaltungen, Webinare z. B. über Cisco-Webex oder
            Zoom, Mediathek
          </h4>
          <ul>
            <li>
              Video- und Audioaufzeichnung mit der Aufzeichnung Ihrer Person
              und/oder Ihrer Matrikelnummer und anschließende Speicherung und
              Zugänglichmachung in der Mediathek
            </li>
            <li>Foren- oder Chatbeiträge</li>
          </ul>
          <h4 class="fom-copy-m-bold">c) Digitale Prüfungen</h4>
          <ul>
            <li>Matrikelnummer zur Zuordnung des Videostreams</li>
            <li>
              Aufnahme der ID-Card (Studierendenausweis) oder des Personalausweises
            </li>
            <li>
              Aufnahme des Raumes, ggf. also auch des für die digitale Prüfung
              genutzten privaten Wohnraumes
            </li>
            <li>IP-Adresse</li>
            <li>Anzahl der angeschlossenen Bildschirme.</li>
            <li>Akkustand des Laptops</li>
            <li>
              Das Webcambild, insbesondere die Bewegung von Augen, Kopf und Mund
            </li>
            <li>Audioaufzeichnung</li>
            <li>
              Zwischenablage des Computers, Mausposition, Browsergröße, Inhalte des
              Browserfensters, weitere geöffnete Browser-Tabs und -Fenster, alle
              während der Nutzung besuchten Webseiten und geöffneten Anwendungen
            </li>
          </ul>
          Die Erhebung und Verarbeitung der Daten im Rahmen von digitalen Prüfungen
          ist Teil der Vertragsdurchführung, wenn Sie mit uns die Durchführung
          dieser Prüfungen als Teil Ihres Studiums vereinbart haben. Ansonsten
          erfolgt Sie auf Basis Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
        </li>
        <h4 class="fom-copy-m-bold">d) Push Nachrichten</h4>
        <p>
          Wir bieten Ihnen den Erhalt von Push-Nachrichten über unsere OC-App an,
          mit denen wir Sie über Vorlesungstermine sowie Klausurtermine und
          –Ergebnisse informieren. Unsere Dozierenden können über Push-Nachrichten
          am vereinfachten Veranstaltungs-Bestätigungsverfahren teilnehmen. Zum
          Erhalt von Push-Nachrichten aktivieren Sie bitte den Button
          „Push-Nachrichten“ in den Einstellungen der OC APP. Rechtsgrundlage für
          diese Verarbeitung ist Ihre Einwilligung und damit Art. 6 Abs. 1 lit. a
          DSGVO. Ihre Einwilligung in die Speicherung und Verwendung Ihrer
          personenbezogenen Daten zum Erhalt unserer Push-Nachrichten können Sie
          jederzeit mit Wirkung für die Zukunft durch die Deaktivierung der
          Push-Nachrichten unter den Einstellungen der OC APP widerrufen.
        </p>
        <li>
          <p class="fom-copy-m-bold">
            § 6 Anonyme Datenverarbeitung zur Webanalyse
          </p>
          Auch bei jedem Zugriff auf unsere Webseite werden verschiedene ergänzende
          technische Informationen wie z.B. Browsertyp/-version, IP-Adresse des
          Nutzers, Datum und Uhrzeit des Zugriffs anhand der von Ihrem Browser
          übermittelten Daten gespeichert. Auch diese Daten werden anonymisiert und
          ausschließlich zu statistischen Zwecken sowie zur bedarfsgerechten
          Gestaltung unseres Internetauftritts verwendet. Eine Zusammenführung
          dieser Daten mit Daten aus der Anmeldung, die eine Identifikation des
          Studienbewerbers oder der Studienbewerberin ermöglicht, erfolgt nicht.
          Diese Zwecke stellen ein berechtigtes Interesse gemäß Art. 6 Abs. 1 lit.
          f) DSGVO dar.
        </li>
      </ul>
      <ul class="terms-list">
        <li>
          <p class="fom-copy-m-bold">§ 7 Übermittlung Ihrer Daten</p>
          <h4 class="fom-copy-m-bold">a) Verantwortliche</h4>
          Soweit wir aufgrund vertraglicher oder gesetzlicher Bestimmungen oder
          aufgrund Ihrer Einwilligung befugt sind, geben wir im Rahmen des mit Ihnen
          bestehenden Vertrags Ihre personenbezogenen Daten auch an andere
          Unternehmen weiter, die Ihre Daten in eigener Verantwortung verarbeiten.
          Unter diesen Voraussetzungen können folgende Empfänger bzw. Kategorien von
          Empfängern Ihre personenbezogenen Daten erhalten:
          <ul>
            <li>Verbundene Unternehmen der FOM iSd. §§ 15 ff AktG</li>
            <li>
              Öffentliche Stellen und Institutionen (z. B. Aufsichtsbehörden) bei
              Vorliegen einer gesetzlichen oder behördlichen Verpflichtung.
            </li>
            <li>
              Anbieter von digitalen Kommunikationsdiensten (z. B. zur
              Bereitstellung von Kommunikationsschnittstellen bei der Durchführung
              von digitalen Prüfungen).
            </li>
          </ul>
          Weitere Datenempfänger können diejenigen Stellen sein, für die Sie uns
          Ihre Einwilligung zur Datenübermittlung erteilt haben.
        </li>
        <li>
          <h4 class="fom-copy-m-bold">b) Auftragsverarbeiter</h4>
          Wir setzen bei der Erbringung der konkreten Dienstleistungen verbundene
          Unternehmen der FOM iSd. §§ 15 ff AktG sowie externe Dienstleister ein,
          die personenbezogene Daten in unserem Auftrag verarbeiten
          („Auftragsverarbeiter“). Konkret gehören hierzu Unternehmen in den
          folgenden Kategorien:
          <ul>
            <li>
              Technische Dienstleister in den Bereichen IT- und Telekommunikation
              (z.B. Hosting-Provider, Kommunikationsanbieter), Archivierung,
              Druckdienstleistung;
            </li>
            <li>
              Anbieter von Webinar-Software bzw. Videokonferenz-Software wie Cisco
              oder Zoom
            </li>
            <li>Anbieter von digitalen Lernplattformen</li>
            <li>
              Dienstleister im Bereich des Proctorings zur Abnahme digitaler
              Prüfungen
            </li>
            <li>
              Dienstleister im Bereich Medien und Marketing (z.B. Webagenturen);
            </li>
            <li>Callcenter.</li>
          </ul>
          <h4 class="fom-copy-m-bold">c) Datenübermittlung in Drittstaaten</h4>
          <p>
            Sofern von Ihnen digitale Angebot der FOM, insbesondere digitale
            Prüfungen in Anspruch genommen werden, werden Teile Ihrer Daten
            (IP-Adresse und ggf. Aufzeichnungen von Service-Anfragen) verschlüsselt
            in Drittländer außerhalb der EU bzw. des EWR übertragen. Bitte beachten
            Sie, dass für diese Drittländer kein Angemessenheitsbeschluss der
            EU-Kommission im Sinne von Art. 45 DSGVO besteht. Zum Schutz ihrer
            personenbezogenen Daten haben wir mit den jeweiligen Datenempfängern in
            den Drittländern jedoch die Einhaltung geeigneter Garantien gemäß Art.
            46 und 47 DSGVO vereinbart. Hierbei handelt es sich um die von der
            EU-Kommission bereitgestellten Standarddatenschutzklauseln sowie
            verbindliche interne Datenschutzvorschriften (sog. Binding Corporate
            Rules). Bei Rückfragen hierzu wenden Sie sich bitte an die in § 9
            genannten Kontaktmöglichkeiten.
          </p>
        </li>
        <li>
          <h4 class="fom-copy-m-bold">§ 8 Dauer der Speicherung Ihrer Daten</h4>
          Ihre personenbezogenen Daten werden von uns gespeichert soweit und solange
          dies für die von uns verfolgten Verarbeitungs- zwecke erforderlich ist.
          Die Speicherung erfolgt grundsätzlich bis zur Beendigung des
          Vertragsverhältnisses, es sei denn, der Studienvertrag berechtigt oder
          verpflichtet uns zu einer Speicherung nach Vertragsende. Soweit über
          diesen Zeitpunkt hinaus gesetzliche oder vertragliche
          Aufbewahrungspflichten bestehen, die eine weitere Speicherung Ihrer Daten
          vorsehen, speichern wir Ihre Daten für diese Zwecke auch über die
          Beendigung des Vertragsverhältnisses hinaus. Daten, für die keine
          gesetzliche oder vertragliche Aufbewahrungspflicht über die Laufzeit des
          Studienvertrages hinaus besteht, werden nach Ablauf der jeweiligen
          Aufbewahrungspflicht anonymisiert, sofern sie nicht ausdrücklich und
          konkret in die weitere Nutzung Ihrer Daten eingewilligt haben, oder die
          weitere Speicherung und Nutzung aufgrund berechtigten Interesses erfolgt.
          <br /><br />
          Im Falle der Zurückweisung Ihrer Anmeldung erfolgt die Anonymisierung
          Ihrer personenbezogenen Daten erst drei Monate nach Beginn des
          Studienganges, für den Sie sich angemeldet haben, um Ihnen ein Nachrücken
          zu ermöglichen.
        </li>
        <li>
          <h4 class="fom-copy-m-bold">
            § 9 Rechte des Betroffenen, Art. 15 ff DSGVO
          </h4>
          <p class="fom-copy-m-bold p-pt-3">
            a) Recht auf Auskunft, Berichtigung, Einschränkung, Löschung und
            Übertragung
          </p>
          Wir geben Ihnen gerne auf Anfrage Auskunft darüber, welche
          personenbezogenen Daten von Ihnen verarbeitet werden. Sollten Ihre
          gespeicherten Daten unrichtig sein, so haben Sie einen Anspruch auf
          entsprechende Berichtigung oder Einschränkung. Sie haben zudem das Recht
          auf Sperrung und Löschung der bei uns zu Ihrer Person gespeicherten Daten,
          wenn der Zweck für die Verarbeitung der Daten wegfällt oder sonstige
          gesetzliche Voraussetzungen vorliegen (Art. 17 DSGVO). Sollten der
          Löschung gesetzliche, vertragliche oder steuerrechtliche bzw.
          handelsrechtliche Aufbewahrungspflichten oder anderweitige gesetzlich
          verankerte Gründe widersprechen, kann statt der Löschung nur die Sperrung
          Ihrer Daten vorgenommen werden. Darüber hinaus haben Sie ein Recht auf
          Übertragung Ihrer Daten.
          <p class="fom-copy-m-bold p-pt-3">b) Widerspruchsrecht</p>
          Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
          ergeben, jederzeit gegen die Verarbeitung Sie betreffender
          personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. f) DSGVO
          (Datenverarbeitung auf der Grundlage einer Interessenabwägung) erfolgt,
          Widerspruch einzulegen.
          <br /><br />
          Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht
          mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe
          für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
          Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung,
          Ausübung oder Verteidigung von Rechtsansprüchen. Der Widerspruch kann
          formfrei erfolgen.
          <br /><br />
          Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden
          wir Ihre personenbezogenen Daten nicht mehr für diese Zwecke verarbeiten.
          <br /><br />
          Zur Geltendmachung der vorgenannten Rechte und/oder um nähere
          Informationen hierüber zu erhalten, wenden Sie sich bitte unter folgender
          Adresse bzw. Kontaktdaten an unseren Datenschutzbeauftragten:
          <br /><br />
          FOM Hochschule für Oekonomie & Management gemeinnützige Gesellschaft mbH
          <br />
          Datenschutzbeauftragter<br />
          Leimkugelstraße 6<br />
          45141 Essen<br />
          E-Mail:
          <a href="mailto:datenschutz@bcw-gruppe.de">datenschutz@bcw-gruppe.de</a>
          <p class="fom-copy-m-bold p-pt-3">c) Beschwerderecht</p>
          Wenn Sie der Ansicht sind, dass die in dieser Datenschutzerklärung
          dargestellte Verarbeitung Ihrer personenbezogenen Daten gegen gesetzliche
          Vorschriften verstößt, können Sie hiergegen, unbeschadet eines
          anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs,
          Beschwerde bei der jeweils zuständigen Aufsichtsbehörde, insbesondere in
          dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des
          Orts des mutmaßlichen Verstoßes, einlegen.
          <br /><br />
          Die für uns zuständige Aufsichtsbehörde ist: <br />Landesbeauftragte für
          Datenschutz und Informationsfreiheit Nordrhein-Westfalen <br />Postfach 20
          04 44 <br />40102 Düsseldorf
          <p class="fom-copy-m-bold p-pt-3">
            § 10 Änderungen der Datenschutzerklärung
          </p>
          Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit unter
          Beachtung der geltenden Datenschutzvorschriften zu ändern. Derzeitiger
          Stand ist Januar 2022.
          <br /><br />
          Über allfällige Änderungen dieser Datenschutzerklärung unter Beachtung der
          geltenden Gesetze und Verordnungen werden Sie jeweils informiert. Bitte
          beachten Sie auch unsere allgemeine Datenschutzerklärung auf unserer
          Homepage unter www.fom.de.
        </li>
      </ul>

      <div class="flex items-center">
        <Checkbox input-id="accept-terms" v-model="accept" :binary="true" />
        <label for="accept-terms" class="mt-px -mb-px checkbox-label">
          Ich akzeptiere die Nutzungs- und Datenschutzbedingungen
        </label>
      </div>
    </template>

    <template #footer>
      <PrimaryButton
        :disabled="!accept"
        label="Speichern"
        @click="acceptTerms"
      />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import { onMounted, ref } from 'vue';
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import { useBcwServices } from "@/composables/http/use-bcw-services";

// Stores
const { aceptTermsOfUse, showTermsOfUse } = useBcwServices();

// States
const visible = ref<boolean>();
const accept = ref<boolean>();
const loading = ref<boolean>(false);

/**
 * Component mounted
 */
onMounted(() => {
  showTerms();
});

/**
 * Check if terms of use has been already accepted
 */
async function showTerms() {
  try {
    await (new Promise(resolve => setTimeout(resolve, 2000)))
    let response = (await showTermsOfUse()) as boolean|string;
    if (typeof response == 'string') {
      response = response == 'true';
    }
    visible.value = response;
  } catch (err) {
    console.error(err)
  }
}

/**
 * Accept terms of use.
 */
async function acceptTerms() {
  if (loading.value) {
    return;
  }
  loading.value = true;

  try {
    const response = await aceptTermsOfUse();
    if (response.status >= 200 && response.status <= 299) {
      visible.value = false;
    } else {
      throw new Error('An unknown error occured.');
    }
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false;
  }
}
</script>

<style>
.p-dialog.terms-of-use {
  @media (min-width: 800px) {
    min-width: 650px;
  }
  
  & .p-dialog-header {
    width: 100%;
    max-width: 90vw;
  }

  & .p-dialog-footer {
    text-align: right;

    button {
      margin: 0 0 0 auto;
      width: fit-content;
    }
  }
}
</style>

<style scoped>
.terms-list {
  list-style: none;
  padding-left: 0;

  &>li {
    margin-bottom: 16px;
  }
}

.checkbox-label {
  margin-top: -4px;
  margin-left: 16px;
}
</style>
